import {
  Card,
  DialogTitle,
  Grid,
  IconButton,
  DialogContent,
  Dialog,
} from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { InfluencerTypes } from 'api';
import { getInfluencerName } from 'helpers/common';
import { CardImage } from './Media';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  influencerData: InfluencerTypes.ItemData;
}

const ImageDialog = (props: Props): JSX.Element | null => {
  const { onClose, isOpen, influencerData } = props;

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          wrap="nowrap"
        >
          <Grid item xs={10}>
            {`${getInfluencerName(influencerData)}`}
          </Grid>
          <Grid item xs="auto">
            <IconButton onClick={onClose}>
              <CloseOutlined />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Card variant="outlined">
          <CardImage
            src={influencerData.profile_picture_url}
            alt={influencerData.profile_name}
            sx={{ height: '75vh' }}
            PlaceholderSx={(theme) => ({
              height: '75vh',
              objectFit: 'none',
              background:
                theme.palette.mode === 'dark'
                  ? theme.palette.grey['900']
                  : theme.palette.grey['100'],
            })}
          />
        </Card>
      </DialogContent>
    </Dialog>
  );
};

export default ImageDialog;
